// extracted by mini-css-extract-plugin
export default {"container":"manufacturer_container__5U3v3","subContainer":"manufacturer_subContainer__Kkbxa","separator":"manufacturer_separator__sfAGP"};